import NoDataToExportError from '../../domain/errors/NoDataToExportError';
import { setModalToDisplay, unsetModalToDisplay } from '../../legacy/actions/modals';
import { SessionsModalTypes } from '../../legacy/reducers/modals';
import { createCommand } from '../../utils';
import { moduleName } from '../state';

export const ExportGeojsonSectionsReportCommand = createCommand(
    `${moduleName}/EXPORT_SECTIONS_REPORT`,
    async (sessionIds: string[], { dispatch, extra }) => {
        try {
            dispatch(setModalToDisplay(SessionsModalTypes.SESSIONS_EXPORT_IN_PROGRESS));

            const data = await extra.externalSessions.exportGeojsonSectionsReport(sessionIds);

            let extension: string;
            let suffix = '';

            switch (data.type) {
                case 'application/geo+json':
                    extension = 'geojson';
                    break;
                case 'text/plain':
                    suffix = 'errors_';
                    extension = 'txt';
                    break;
                default:
                    extension = 'zip';
            }

            extra.download.execute(data, `export_geojson_${suffix}${new Date().toISOString()}.${extension}`);

            dispatch(unsetModalToDisplay());
        } catch (e: any) {
            switch (e.constructor) {
                case NoDataToExportError:
                    dispatch(setModalToDisplay(SessionsModalTypes.SESSIONS_EXPORT_NO_ANNOTATION));
                    break;
                default:
                    dispatch(setModalToDisplay(SessionsModalTypes.SESSIONS_EXPORT_FAILURE));
                    break;
            }
        }
    },
);
